<template lang="pug">
  .select(v-on-clickaway="away", :class="{ disabled: disabled }")
    .select-trigger(@click.stop="toggle", ref="trigger")
      h6(v-if="header") {{ header }}
      .selected-value
        .select-trigger-input(v-if="selected") {{ selected[label] }}
        font-awesome-icon(:icon="['fas', 'angle-down']")
    .select-menu(v-show="!disabled && (isOpen)", ref="selectMenu")
      .select-wrap(@click="hide")
        .select-option(v-if="empty", @click="selectOption(empty)") {{ empty[label] }}
        .select-option(v-for="option in options", @click="selectOption(option)") {{ option[label] }}
</template>

<script>

import { mixin as clickaway } from 'vue-clickaway'

export default {
  name: 'SelectInput',
  components: {
  },
  mixins: [ clickaway ],
  props: {
    value: [String, Number, Object],
    options: Array,
    header: {
      type: String,
      default: null
    },
    empty: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: 'name'
    },
    id: {
      type: String,
      default: '_id'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
  },
  data () {
    return {
      isOpen: this.open
    }
  },
  computed: {
    selected () {
      let selected = {
        [this.label]: 'None',
        [this.id]: null
      }

      if (this.value) {
        selected = this.options.find(option => option[this.id] === this.value)
      } else if (this.empty) {
        selected = this.empty
      }
      return selected
    }
  },
  methods: {
    toggle () {
      if (this.disabled) return
      this.isOpen = !this.isOpen

      if (this.isOpen) {
        this.$emit('openDropdown')
      } else {
        this.$emit('closeDropdown')
      }
    },
    selectOption (option) {
      this.$emit('input', option._id)
      this.$emit('change')
    },
    hide () {
      this.away()
    },
    away () {
      this.isOpen = false
    }
  },
  watch: {
    open: function (val) {
      this.isOpen = val
    },
    value: function (val) {
    }
  },
}
</script>

<style lang="stylus" scoped>
  .select
    position relative
    &.disabled
      cursor not-allowed
      opacity .5

    .select-trigger
      border $border-default
      border-radius $border-radius
      font-family inherit
      font-size inherit
      padding $spacing
      width 100%
      h6
        margin-bottom 5px
    .selected-value
      display flex
    .select-trigger-input
      flex 1

    .select-menu
      left auto
      position absolute
      right 0
      z-index 1
      width 100%
      .select-wrap
        background-color #fff
        border 2px solid #edeff0
        box-shadow 0 6px 12px rgba(0,0,0,.175)
        border-radius 4px
        margin 2px 0 0

      .select-option
        cursor pointer
        padding $spacing
        &:hover
          background-color $background-color
</style>
